import { hasRealmRole } from './authUtils';

// The single source of truth for who may reach each "Super Admin" surface. Both the sidebar
// entry (src/components/main/main-sidebar.tsx) and the route gate (SuperAdminGuard) read this
// map, so a menu item can never disagree with the page it links to.
//
// 'playwright_test_user' is the seeded e2e account's realm role (it holds no staff role at
// all: acendauser / playwright_test_user / default-roles-asturtest). It is listed only on the
// surfaces whose specs drive real page content; the surfaces whose specs assert the redirect
// away deliberately omit it. This mirrors the existing isAcendaStaffOrPlaywrightTestUser
// convention rather than introducing a second one.
const PLAYWRIGHT_TEST_USER = 'playwright_test_user';
const MANAGEMENT = 'acenda_the_management';
const SUPERUSER = 'superuser';

export const SUPER_ADMIN_SURFACES = {
  integrations_admin: [SUPERUSER, PLAYWRIGHT_TEST_USER],
  organizations_admin: [MANAGEMENT, SUPERUSER, PLAYWRIGHT_TEST_USER],
  dashboard_alerts_admin: [SUPERUSER, PLAYWRIGHT_TEST_USER],
  service_platform_calls_health_admin: [SUPERUSER],
  atts_commonality_global_admin: [SUPERUSER],
  category_plans_admin: [MANAGEMENT, SUPERUSER],
} as const;

export type SuperAdminSurface = keyof typeof SUPER_ADMIN_SURFACES;

export const superAdminSurfaceRoles = (surface: SuperAdminSurface): string[] => [...SUPER_ADMIN_SURFACES[surface]];

export const canAccessSuperAdminSurface = (surface: SuperAdminSurface): boolean => hasRealmRole(superAdminSurfaceRoles(surface));
